import React, { useEffect, useRef } from 'react'

import { useAuth } from '../../../../context/AuthContext'
import { toast } from '../../common/Toast/toast';
import { useNavigate } from 'react-router-dom'
import { StudentDashboard2 } from './StudentDashboard2'
import StudentAccessBanner from './StudentAccessBanner'

/**
 * /student-dashboard.
 *
 * This used to compose the dashboard with a stack of full-width strips
 * beneath it — the tour video, the blog roll, a feedback banner and the
 * contact desks — each on a white ground that was neither the view's
 * ground nor its card.
 *
 * All four now live inside StudentDashboard2, which places them where
 * they belong in whichever of its two views is showing: the student's
 * LinkedIn view puts the desks at the foot of the left rail, the video
 * and feedback in the right, and the blog posts at the tail of the feed;
 * the staff view shows none of them, because staff reading a student's
 * record are not the audience for "take a tour". So all this route does
 * now is guard the permission.
 */
function Student() {
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const { hasPermission } = useAuth();

  useEffect(() => {
    if (!hasPermission('student-dashboard', 'view', 'lms')) {
      if (!hasShownToast.current) {
        toast.error('You do not have permission to add departments.');
        navigate('/');
        hasShownToast.current = true;
      }
    }
  }, [hasPermission, navigate]);

  return (
    <>
      <StudentAccessBanner />
      <StudentDashboard2 />

      {/* Chat / AI assistant entry point — temporarily disabled, do not remove.
      <div className="mb-5">
        <div className="sd-assistant-banner">
          <div className="p-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div className="d-flex align-items-center mb-3 mb-md-0">
              <div className="bg-white p-1 rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm" style={{ width: '54px', height: '54px', flexShrink: 0 }}>
                <Sparkles size={26} color="#0E7C6B" />
              </div>
              <div className="text-start">
                <h4 className="sd-assistant-title">Chat</h4>
                <p className="sd-assistant-sub">Ask our AI assistant about courses, batches, or admissions — or message any trainer directly and see who's online, all in one place.</p>
              </div>
            </div>
            <button
              className="sd-assistant-btn"
              onClick={() => navigate('/assistant')}
            >
              Start Chat
            </button>
          </div>
        </div>
      </div>
      */}
    </>
  );
}

export default Student
